import { CacheHelper } from "@/app/utils/cache-helper";
class DataGridState {
    constructor(columns, sorter, includeDeleted) {
        this.columns = columns;
        this.sorter = sorter;
        this.includeDeleted = includeDeleted;
    }
}
/**
* Store and Restore the Data Grid State (visible columns and sort column).
*/
export class DataGridStateHelper {
    static storeDataGridState(key, columns, sorter, includeDeleted = false) {
        var state = new DataGridState(columns, sorter, includeDeleted);
        CacheHelper.storeItem(this.storageDataGridKey, key, state);
    }
    static loadDataGridState(key, columns, sorter) {
        var state = CacheHelper.getItem(this.storageDataGridKey, key);
        if (state == null)
            return null;
        // restore visible property
        if (state.columns != null) {
            state.columns.forEach(column => {
                var currentColumn = columns.filter(col => col.fieldName == column.fieldName);
                if (currentColumn != null && currentColumn.length > 0) {
                    currentColumn[0].visible = column.visible;
                }
            });
        }
        // restore sorter
        if (state.sorter != null && state.sorter.currentSort != null) {
            sorter.currentSort.fieldName = state.sorter.currentSort.fieldName;
            sorter.currentSort.direction = state.sorter.currentSort.direction;
        }
        return state;
    }
}
DataGridStateHelper.storageDataGridKey = "DataGridState";
